// Utils
import { popupSelector } from '../../../../../components/popupPanel/popupOpenSelector';

// Constants
import { NOTIFICATIONS_POPUP_ID } from './notificationsPopupConstants';

export const getSelectedNotificationData = (state) =>
    popupSelector(NOTIFICATIONS_POPUP_ID)(state).get('selectedNotificationData');

export const getSelectedNotificationId = (state) =>
    popupSelector(NOTIFICATIONS_POPUP_ID)(state).getIn(['selectedNotificationData', 'notificationId']);
